module.exports = __webpack_public_path__ + "static/media/chaafoBanner1.32772640.png";